import { EnvironmentProviders, Provider } from '@angular/core';
import {
  PEPPOL_CONNECTION_API,
  PEPPOL_MESSAGES_API,
} from 'wflow-features/peppol';
import { PeppolConnectionAPIService } from './peppol-connection.service';
import { PeppolMessagesAPIService } from './peppol-messages.service';

export function providePeppolApi(): (Provider | EnvironmentProviders)[] {
  return [
    { provide: PEPPOL_MESSAGES_API, useExisting: PeppolMessagesAPIService },
    { provide: PEPPOL_CONNECTION_API, useExisting: PeppolConnectionAPIService },
  ];
}
